import { Section, Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import { width } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   cursor: pointer;\n   list-style-type: none;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   margin: 4px 0;\n\n   & a {\n      line-height: 24px;\n      font-size: 16px;\n\n      color: ", ";\n      display: block;\n      width: 100%;\n      margin: auto;\n      font-family: ", ";\n      text-decoration: none;\n      whitespace: nowrap;\n\n      &:active {\n         color: ", ";\n      }\n\n      &:hover {\n         textdecoration: underline;\n      }\n   }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   font-family: inherit;\n   -webkit-font-smoothing: antialiased;\n   display: flex;\n   flex-direction: column;\n   vertical-align: middle;\n   text-align: center;\n   text-decoration: none;\n   appearance: none;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   margin-top: 20px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   line-height: normal;\n   justify-content: center;\n   align-items: center;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 0;\n   line-height: normal;\n   text-align: center;\n   color: #000;\n   font-weight: bold;\n   font-size: 1.17em;\n   line-height: 3em;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 10px;\n   text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   background: #f0f0f0;\n   border: 10px solid #fafafa;\n   width: 100%;\n   height: 100%;\n   margin: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   align-content: stretch;\n   align-items: stretch;\n   justify-content: space-between;\n   margin: 0 3vw 0 3vw;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Panels = styled("div", {
  width: {
    default: function _default() {
      return [12];
    },
    type: [Array]
  }
})(_templateObject(), width);
var Panel = styled("div", {})(_templateObject2());
var Body = styled("div", {})(_templateObject3());
var Title = styled("h3", {})(_templateObject4());
var Navigation = styled("nav", {})(_templateObject5());
var Image = styled("img", {})(_templateObject6());
var NavBar = styled("ul", {})(_templateObject7());
var NavItem = styled("li", {})(_templateObject8(), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.primaryColor;
});

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];

    var renderLinks = function renderLinks(panelIndex, links) {
      return links.map(function (link, index) {
        return h(NavItem, [h("RouterLink", {
          "attrs": {
            "to": link.url,
            "id": link.id
          }
        }, [link.label])]);
      });
    };

    var renderPanels = function renderPanels(panels) {
      var width = 12 / panels.length;
      return panels.map(function (panel, panelIndex) {
        return h(Col, {
          "key": panelIndex,
          "attrs": {
            "width": [12, 12, width]
          }
        }, [h(Panel, [h(Body, [h(Image, {
          "attrs": {
            "src": panel.icon.url,
            "alt": panel.icon.alt
          }
        }), h(Title, [panel.title]), h(Navigation, [h(NavBar, [renderLinks(panelIndex, panel.links)])])])])]);
      });
    };

    return h(Section, {
      "attrs": {
        "mt": "-10px"
      }
    }, [h(Center, {
      "attrs": {
        "flexDirection": "column"
      }
    }, [h(Row, [renderPanels(this.copy.panels)])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
